import { schema } from 'normalizr';
import { SCHEMA_TYPE_NOTIFICATION_CHANNELS } from '../constants/schemaTypes';

import userSchema from './user';
import orgSchema from './org';

const notificationChannelSchema = new schema.Entity(SCHEMA_TYPE_NOTIFICATION_CHANNELS);

notificationChannelSchema.define({
  owner: userSchema,
  org: orgSchema,
});

export default notificationChannelSchema;
